// FilterHeader.tsx – Component header tùy chỉnh
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { IHeaderParams } from 'ag-grid-community';
import { DatePicker } from 'antd';
import { Dayjs } from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { FilterIcon } from '../../../../../CustomersV2/Modal/FilterIcon';
import useDebounce from '../../../../../../hook/useDebounce';
import useThrottle from '../../../../../../hook/useThrottle';
import { getFilterListPhoneCustomer, IPhoneFilterListPhoneCustomer } from '../../../../../../api/customer/customerApi';
import { getListCustomerTypes, getlistDistrictCustomer, getlistProvinceCustomer, getListServiceInvoiceBranch, getlistUnitCustomer, ICustomerTypes, ITag } from '../../../../../../api/selectOption/selectOptionsApi';
import { getListCodeCustomer, getListProvinceChild, getSLChassisNoByCustomerId, getSLUnitByPermission, ICodeCustomer, IProvince, IprovinceChild } from '../../../../../../api/selectOptions/selectOptionsApi';
import { fommatdataCodeCustomer, fommatdataDefault, fommatdataType, fommatSelectOption } from '../../../../../../until';
import { selectorInfoUser } from '../../../../../../store/slices/infoUserSlice';
import useLoading from '../../../../../../hook/useLoading';
import { dataGender, dataTypeCustomer } from '../../../../../../services/data';
import { selectorCategoryCarIds } from '../../../../../../store/slices/categoryCarSlice';
import ModalFilterDatePicker from '../../../../../CustomersV2/Modal/ModalFilterDatePicker';
import { ModalFilterTypeCustomer } from '../../../../../CustomersV2/Modal/ModalFilterTypeCustomer';
import { ModalProvince } from '../../../../../CustomersV2/Modal/ModalProvince';
import { IDataDefaulFilterList } from '../../../VehicleVersionTable/Modal/FilterHeaderVehicleVersionTable';
import ModalFilter from '../ModalFilter';
import { convertNationwideValueToTree_V2 } from '../../../../../../api/unit/unitApi';
import ModalFilteCar from './ModalFilteCar';
import { ModalTreeCar } from './ModalTreeCar';

export interface IDataDefaulFilterCar {
  // search?: string;

  vehicleChassisNo?: string[]//Số khung xe
  unitId?: number[]//Đơn vị mua xe
  branchId?: number[]//Đơn vị làm dịch vụ

}
const { RangePicker } = DatePicker;
interface FilterHeaderProps extends IHeaderParams {
  dataFilterList: IDataDefaulFilterCar
  customerId: number
  fieldLabel?: string;
  listFilterIcon?: string[]

  setDataFilterList: (dataFilterList: IDataDefaulFilterCar) => void,
}

const FilterHeaderCar: React.FC<FilterHeaderProps> = (props) => {

  const pushLoading = useLoading()
  const { unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const {
    displayName, column, api, dataFilterList,
    customerId,
    listFilterIcon,
    setDataFilterList
  } = props;

  const prevSearchRef = useRef<string | undefined>(undefined);
  const scrollRef = useRef<Record<string, HTMLDivElement | null>>({});

  const columnId = column.getColId()
  const isFilterIcon = listFilterIcon?.includes(columnId) ?? false

  const [activeSort, setActiveSort] = useState<null | 'asc' | 'desc'>(null);

  const [openModal, setOpenModal] = useState(false)
  const [openModalTypeCustomer, setOpenModalTypeCustomer] = useState(false)
  const [openModalTree, setOpenModalTree] = useState(false)
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [checkShowSearch, setCheckShowSearch] = useState(false);

  const [checkedValues, setCheckedValues] = useState<(string | number)[]>();

  // setDataListNationwide(unitApi.convertNationwideTree(result.data))

  const [sLUnitByPermission, setSLUnitByPermission] = useState<any>()
  const [sLChassisNo, setSLChassisNo] = useState<ITag[]>([])

  const [sLCustomerType, setSLCustomerType] = useState<ICustomerTypes[]>([])
  const [sLProvince, setSLProvince] = useState<IProvince[]>([])
  const [sLDistrict, setSLDistrict] = useState<ITag[]>([])
  const [sLCodeCustomer, setSLCodeCustomer] = useState<ICodeCustomer[]>([])
  const [sLProviChild, setSLProviChild] = useState<IprovinceChild[]>([])
  const [sLUnit, setSLUnit] = useState<ITag[]>([])
  const [sLPhoneV2, setSLPhoneV2] = useState<any[]>([])


  const [search, setSearch] = useState<string>()


  const [paginationFilterHeader, setPaginationFilterHeader] = useState({
    own_chassis_no: { current: 1, pageSize: 30, total: 0 },
    cusTel: { current: 1, pageSize: 30, total: 0 },
    cusCode: { current: 1, pageSize: 30, total: 0 }
  });

  const toNumberArray = (arr: (string | number)[]) => {
    return arr.map(Number).filter(Number.isFinite) as number[]
  }

  const toStringArray = (arr: (string | number)[]) => arr.map(String);

  const gSLFilterData = () => {
    if (openModal || openModalTree) {
      switch (columnId) {
        case 'own_chassis_no':
          return sLChassisNo;
        // "Đơn vị mua xe"
        case 'own_branch_name':
          return sLUnitByPermission;
        //Đơn vị làm dịch vụ"
        case 'branch_service_provider':
          return sLUnit;
        // case 'cus_code':
        //   return fommatdataCodeCustomer(sLCodeCustomer);
        // case 'cus_gender_name':
        //   return fommatdataDefault(dataGender);
        // case 'cus_type_name':
        //   return fommatdataType(dataTypeCustomer);
        // case 'cus_city':
        //   return fommatSLDistrict(sLProvince);
        // case 'cus_ward':
        //   return fommatSLDistrict(sLDistrict);
        // case 'cus_branch_name':
        //   return sLUnit;
        // case 'cus_tel':
        //   return sLPhoneV2;
        default:
          return [];
      }

    } else {
      return []
    }
  }

  //Đơn vị mua xe,Đơn vị làm dịch vụ: 
  const gSLUnitByPermission = async () => {
    pushLoading(true)
    const result = await getSLUnitByPermission(
      unitTemp
    )
    if (result?.status) {
      setSLUnitByPermission(convertNationwideValueToTree_V2(result.data))
    } else {
    }
    pushLoading(false)
  }

  const gSLServiceInvoiceBranch = async () => {
    pushLoading(true)
    const result = await getListServiceInvoiceBranch(
      search, customerId
    )
    if (result?.status) {
      const units = result.data.map(item => ({
        id: item.id,
        title: item.title,
      }));

      setSLUnit(units)
    } else {
    }
    pushLoading(false)
  }

  const gSLChassisNoByCustomerId = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await getSLChassisNoByCustomerId(
      customerId
    );
    if (result?.status) {
      setSLChassisNo(prev =>
        current === 1 ?
          result.data :
          [...prev, ...result.data]
      );

      setPaginationFilterHeader({
        ...paginationFilterHeader,
        own_chassis_no: { ...paginationFilterHeader.own_chassis_no, current: current, total: result.total || 0 }
      })
    }
    pushLoading(false)
  }, 300)


  const gSLFilterListPhoneCustomer = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await getFilterListPhoneCustomer(
      permittedCategoryCarIds,
      30, current, search, unitTemp
    );
    if (result?.status) {
      // Append nếu current > 1
      setSLPhoneV2(prev =>
        current === 1 ?
          fommatdataPhoneFilter(result.data) :
          [...prev, ...fommatdataPhoneFilter(result.data)]
      );


      setPaginationFilterHeader({
        ...paginationFilterHeader,
        cusTel: { ...paginationFilterHeader.cusTel, current: current, total: result.total || 0 }
      })
    }
    pushLoading(false)
  }, 300)

  const getListUnit = async () => {
    pushLoading(true)
    const result = await getlistUnitCustomer(
      search, unitTemp
    )
    if (result?.status) {

      const units = result.data.map(item => ({
        id: item.id,
        title: item.title,
      }));

      setSLUnit(units)
    }
    pushLoading(false)
  }

  const gSListProvinceChild = async () => {
    pushLoading(true)
    const result = await getListProvinceChild(search);
    if (result?.status) {
      setSLProviChild(result.data)
    }
    pushLoading(false)
  }

  const gSListCodeCustomer = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await getListCodeCustomer(
      permittedCategoryCarIds,
      undefined, search, unitTemp, undefined,
      30, current
    );
    if (result?.status) {

      setSLCodeCustomer(prev =>
        current === 1 ?
          result.data :
          [...prev, ...result.data]
      );

      setPaginationFilterHeader({
        ...paginationFilterHeader,
        cusCode: { ...paginationFilterHeader.cusCode, current: current, total: result.total || 0 }
      })
    }
    pushLoading(false)
  }, 300)

  const gSLCustomerTypes = async () => {
    pushLoading(true)
    const result = await getListCustomerTypes(search);
    if (result?.status)
      setSLCustomerType(result.data)
    pushLoading(false)
  }

  const gSLProvince = async () => {
    pushLoading(true)
    const result = await getlistProvinceCustomer(
      search, unitTemp
    );
    if (result?.status) {
      setSLProvince(result.data)
    }
    pushLoading(false)
  }

  const gSLDistrict = async () => {
    pushLoading(true)
    const result = await getlistDistrictCustomer(search, unitTemp);
    if (result?.status) {
      setSLDistrict(result.data)
    }
    pushLoading(false)
  }

  const isColumnFiltered = useMemo(() => {
    switch (columnId) {
      case 'own_chassis_no': return !!dataFilterList?.vehicleChassisNo?.length;
      // "Đơn vị mua xe"
      case 'own_branch_name': return !!dataFilterList?.unitId?.length;
      //Đơn vị làm dịch vụ
      case 'branch_service_provider': return !!dataFilterList?.branchId?.length;

      // case 'cus_type_name': return !!dataFilterList.businessCheck?.length;
      // case 'cus_branch_name': return !!dataFilterList.listUnit?.length;
      // case 'cus_gender_name': return !!dataFilterList.gender?.length;
      // case 'cus_ward': return !!dataFilterList.listWard?.length;
      // case 'cus_code': return !!dataFilterList.listCode?.length;
      // case 'cus_tel': return !!dataFilterList.listPhone?.length;
      // case 'cus_lifecycle_status': return !!dataFilterList.listType?.length;
      // case 'cus_birth_day': return !!(dataFilterList.dateStart);
      // case 'cus_city': return !!dataFilterList.listProvince?.length;
      default: return false;
    }
  }, [columnId, dataFilterList]);


  const fommatSLDistrict = (arr: ITag[]) => {
    const newData = arr?.map(item => ({
      id: item.id,
      title: item.title
    }));
    return newData
  }

  // const fommatdataPhoneFilter = (arr: IPhoneFilterListPhoneCustomer[]) => {
  //   const unique = [...new Set(arr.map(item => item.phone))].map(phone => ({ id: phone, title: phone }));
  //   return [...unique, { id: '0', title: NO_DATA }];
  // }

  //Tạm ẩn cả a tui viết chưa xong
  const fommatdataPhoneFilter = (arr: IPhoneFilterListPhoneCustomer[]) => {
    const unique = [...new Set(arr.map(item => item.phone))].map(phone => ({ id: phone, title: phone }));
    return [...unique];
  }

  const handleSortRequest = (order: 'asc' | 'desc' | null) => {
    let newSort: null | 'asc' | 'desc' = null;
    switch (order) {
      case 'asc':
        newSort = 'desc'
        break;
      case 'desc':
        newSort = null
        break;
      default:
        newSort = 'asc'
        break;
    }
    setActiveSort(newSort);
    api.applyColumnState({
      state: [
        {
          colId: columnId,
          sort: newSort || undefined,
        }
      ],
      defaultState: { sort: null },
    });
  };



  const handleFilterClick = useThrottle(() => {
    switch (columnId) {
      case 'own_chassis_no':
        setCheckedValues(dataFilterList?.vehicleChassisNo)
        setCheckShowSearch(true);
        setOpenModal(true);
        break;

      // "Đơn vị mua xe"
      case 'own_branch_name':
        setCheckedValues(dataFilterList?.unitId)
        setCheckShowSearch(false);
        setOpenModalTree(true)
        break;
      // "Đơn vị dịch vụ"
      case 'branch_service_provider':
        setCheckedValues(dataFilterList?.branchId)
        setCheckShowSearch(false);
        setOpenModal(true)
        break;
      // case 'cus_lifecycle_status':
      //   setCheckedValues(dataFilterList.listType)
      //   setOpenModalTypeCustomer(true);
      //   setCheckShowSearch(true);
      //   break;
      // case 'cus_birth_day':
      //   setIsDatePickerOpen(true);
      //   break;
      // case 'cus_gender_name':
      //   setCheckedValues(dataFilterList.gender)
      //   setOpenModal(true)
      //   break;
      // case 'cus_type_name':
      //   setCheckedValues(dataFilterList.businessCheck)
      //   setOpenModal(true)
      //   break;
      // case 'cus_branch_name':
      //   setCheckedValues(dataFilterList.listUnit)
      //   setCheckShowSearch(true);
      //   setOpenModal(true)
      //   break;
      // case 'cus_city':
      //   setCheckedValues(dataFilterList.listProvince)
      //   setCheckShowSearch(true);
      //   setOpenModal(true)
      //   break;
      // case 'cus_ward':
      //   setCheckedValues(dataFilterList.listWard)
      //   setCheckShowSearch(true);
      //   setOpenModal(true)
      //   break;
      // case 'cus_code':
      //   setCheckedValues(dataFilterList.listCode)
      //   setCheckShowSearch(true);
      //   setOpenModal(true)
      //   break;
      // case 'cus_tel':
      //   setCheckedValues(dataFilterList.listPhone)
      //   setCheckShowSearch(true);
      //   setOpenModal(true)
      //   break;

      default: {
        setOpenModal(false);
        setOpenModalTree(false)
        break;
      }

    }
  }, 1000)

  const handleSearch = useDebounce((value?: string) => {
    setSearch(value);

  }, 500);

  const handleFilterColumnSelectChange = (columnCode: string, value?: (string | number)[]) => {

    switch (columnCode) {
      case 'own_chassis_no': {
        setDataFilterList({ ...dataFilterList, vehicleChassisNo: toStringArray(value ?? []) })
        break;
      }
      // "Đơn vị mua xe"
      case 'own_branch_name': {
        setDataFilterList({ ...dataFilterList, unitId: toNumberArray(value ?? []) })
        break;
      }
      // Đơn vị làm dịch vụ"
      case 'branch_service_provider': {
        setDataFilterList({ ...dataFilterList, branchId: toNumberArray(value ?? []) })
        break;
      }


      // case 'cus_type_name':
      //   setDataFilterList({ ...dataFilterList, businessCheck: toNumberArray(value) })
      //   break;
      // case 'cus_branch_name':
      //   setDataFilterList({ ...dataFilterList, listUnit: toNumberArray(value) })
      //   break;
      // case 'cus_gender_name':
      //   setDataFilterList({ ...dataFilterList, gender: toNumberArray(value) })
      //   break;
      // case 'cus_city':
      //   setDataFilterList({ ...dataFilterList, listProvince: toNumberArray(value) })
      //   break;
      // case 'cus_ward':
      //   setDataFilterList({ ...dataFilterList, listWard: toNumberArray(value) })
      //   break;
      // case 'cus_code':
      //   setDataFilterList({ ...dataFilterList, listCode: toStringArray(value) })
      //   break;
      // case 'cus_tel':
      //   setDataFilterList({ ...dataFilterList, listPhone: toStringArray(value) })
      //   break;
      // case 'cus_lifecycle_status':
      //   setDataFilterList({ ...dataFilterList, listType: toNumberArray(value) })
      //   break;
      default:
        break;
    }
  }


  const onPopupScroll = (e: any, columnId: string) => {
    const target = e.target;
    const isBottom =
      (target.scrollTop + target.offsetHeight) >= target.scrollHeight - 100;


    switch (columnId) {
      case "own_chassis_no": {
        const { current, total } = paginationFilterHeader.own_chassis_no;
        const hasMore = sLChassisNo?.length < total;

        if ((current + 1) * 30 >= total) {
          return
        }
        if (isBottom && hasMore) {
          pushLoading(true)
          const nextPage = current + 1;
          gSLChassisNoByCustomerId(nextPage);
        }
        pushLoading(false)
        break;
      }

      // case "cus_tel": {
      //   const { current, total } = paginationFilterHeader.cusTel;
      //   const hasMore = sLPhoneV2.length < total;

      //   if ((current + 1) * 30 >= total) {
      //     return
      //   }
      //   if (isBottom && hasMore) {
      //     pushLoading(true)
      //     const nextPage = current + 1;
      //     gSLFilterListPhoneCustomer(nextPage);
      //   }
      //   pushLoading(false)
      //   break;
      // }
      // case "cus_code": {
      //   const { current, total } = paginationFilterHeader.cusCode;
      //   const hasMore = sLCodeCustomer.length < total;

      //   if ((current + 1) * 30 >= total) {
      //     return
      //   }
      //   if (isBottom && hasMore) {
      //     pushLoading(true)
      //     const nextPage = current + 1;
      //     gSListCodeCustomer(nextPage);
      //   }
      //   pushLoading(false)
      //   break;
      // }

      default:
        break;
    }
  };

  useEffect(() => {
    if (openModal || openModalTree) {
      switch (columnId) {
        case 'own_chassis_no': {
          if (!sLChassisNo?.length && !search) {
            gSLChassisNoByCustomerId();
            return
          }

          if (search !== prevSearchRef.current) {
            gSLChassisNoByCustomerId();
            // cập nhật prevSearchRef sau khi chạy
            prevSearchRef.current = search;

            if (scrollRef.current["own_chassis_no"]) {
              scrollRef.current["own_chassis_no"]?.scrollTo({ top: 0 });
            }
          }
          break;
        }

        // "Đơn vị mua xe"
        case 'own_branch_name':
          if (!sLUnitByPermission?.length) {
            gSLUnitByPermission();
          }
          if (search !== prevSearchRef.current) {
            gSLUnitByPermission();
          }
          // cập nhật prevSearchRef sau khi chạy
          prevSearchRef.current = search;
          break;

        // Đơn vị làm dịch vụ"
        case 'branch_service_provider':
          if (!sLUnitByPermission?.length) {
            gSLServiceInvoiceBranch();
          }
          if (search !== prevSearchRef.current) {
            gSLServiceInvoiceBranch();
          }
          // cập nhật prevSearchRef sau khi chạy
          prevSearchRef.current = search;
          break;
        // case 'cus_city':
        //   if (!sLProvince.length) {
        //     gSLProvince();
        //   }
        //   if (search !== prevSearchRef.current) {
        //     gSLProvince();
        //   }
        //   // cập nhật prevSearchRef sau khi chạy
        //   prevSearchRef.current = search;
        //   break;
        // case 'cus_ward':
        //   if (!sLDistrict.length) {
        //     gSLDistrict();
        //   }
        //   if (search !== prevSearchRef.current) {
        //     gSLDistrict();
        //   }
        //   // cập nhật prevSearchRef sau khi chạy
        //   prevSearchRef.current = search;
        //   break;


        // case 'cus_branch_name':
        //   if (!sLUnit.length) {
        //     getListUnit();
        //   }
        //   if (search !== prevSearchRef.current) {
        //     getListUnit();
        //   }
        //   // cập nhật prevSearchRef sau khi chạy
        //   prevSearchRef.current = search;
        //   break;

        // case 'cus_code': {
        //   if (!sLCodeCustomer.length && !search) {
        //     gSListCodeCustomer();
        //     return
        //   }

        //   if (search !== prevSearchRef.current) {
        //     gSListCodeCustomer();
        //     // cập nhật prevSearchRef sau khi chạy
        //     prevSearchRef.current = search;

        //     if (scrollRef.current["cus_code"]) {
        //       scrollRef.current["cus_code"]?.scrollTo({ top: 0 });
        //     }
        //   }
        //   break;
        // }

        // case 'cus_tel': {
        //   if (!sLPhoneV2.length && !search) {
        //     gSLFilterListPhoneCustomer();
        //     return
        //   }

        //   if (search !== prevSearchRef.current) {
        //     gSLFilterListPhoneCustomer();
        //     // cập nhật prevSearchRef sau khi chạy
        //     prevSearchRef.current = search;

        //     if (scrollRef.current["cus_tel"]) {
        //       scrollRef.current["cus_tel"]?.scrollTo({ top: 0 });
        //     }
        //   }
        //   break;
        // }

        default:
          break;
      }


    }
  }, [openModal, openModalTree, search])

  // useEffect(() => {
  //   if (!sLCustomerType.length) {
  //     if (openModalTypeCustomer && columnId === 'cus_lifecycle_status') {
  //       gSLCustomerTypes();
  //     }
  //   }
  //   if (search !== prevSearchRef.current) {
  //     gSLCustomerTypes();
  //   }
  //   // cập nhật prevSearchRef sau khi chạy
  //   prevSearchRef.current = search;
  // }, [openModalTypeCustomer, search]);

  // useEffect(() => {
  //   if (!sLProviChild.length) {
  //     if (openModalTree && columnId === 'district') {
  //       gSListProvinceChild();
  //     }
  //   }
  //   if (search !== prevSearchRef.current) {
  //     gSListProvinceChild();
  //   }
  //   // cập nhật prevSearchRef sau khi chạy
  //   prevSearchRef.current = search;
  // }, [openModalTree, search]);

  return (
    <>
      <ModalFilteCar
        isOpen={openModal}
        scrollRef={scrollRef}
        columnCode={columnId}
        checkShowSearch={checkShowSearch}
        selectedValues={checkedValues}


        sLData={gSLFilterData()}
        handleSearch={handleSearch}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        closeModal={setOpenModal}

        onPopupScroll={onPopupScroll}
      />

      <ModalTreeCar
        columnCode={columnId}
        selectedValues={checkedValues}
        isOpen={openModalTree}
        sLData={gSLFilterData()}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        handleSearch={handleSearch}
        closeModal={setOpenModalTree}
      />
      {/* <ModalFilterTypeCustomer
        selectedValues={checkedValues}
        columnCode={columnId}
        isOpen={openModalTypeCustomer}
        dataFiler={sLCustomerType}
        handleSearch={handleSearch}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        closeModal={setOpenModalTypeCustomer}
      /> */}
      {/* <ModalProvince
        columnCode={columnId}
        selectedValues={checkedValues}
        isOpen={openModalTree}
        dataFiler={sLProviChild}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        handleSearch={handleSearch}
        closeModal={setOpenModalTree}
      /> */}

      {/* <ModalFilterDatePicker
        isOpen={isDatePickerOpen}
        rangeValue={[dataFilterList?.dateStart, dataFilterList?.dateEnd]}
        handleDateChange={handleFilterColumnDate}
        closeModal={setIsDatePickerOpen}
      /> */}

      <div className='d-flex align-center gap-1'>
        <span>{displayName}</span>
        <div className='d-flex align-center gap-1'>
          <div className='d-flex flex-column'
            onClick={() => handleSortRequest(activeSort)}
          >
            <CaretUpOutlined
              hidden={activeSort === 'desc'}
              className={`cursor-pointer text-10-px `}
            />
            <CaretDownOutlined
              hidden={activeSort === 'asc'}
              className={`cursor-pointer text-10-px `}
            />
          </div>
          <div
            hidden={!isFilterIcon}
            onClick={handleFilterClick}
            style={{ marginLeft: 0, cursor: 'pointer' }}
          >
            <FilterIcon isFiltered={isColumnFiltered} />
          </div>
        </div>

      </div>
    </>

  );
};

export default FilterHeaderCar;
